import { useParams, Link } from 'react-router-dom'
import { useEffect, useState } from 'react'

import {
  ArrowLeft,
  Calendar,
  DollarSign,
  Globe,
  Award,
  BookOpenCheck
} from 'lucide-react'

import './CourseDetail.css'
import { getCourseBySlug } from '../../Components/Lib/contentful'
//import { getCourseBySlug } from '../../lib/contentful/courses' // adjust path if needed

export default function CourseDetail() {

  const { courseSlug } = useParams()

  const [course, setCourse] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {

    async function loadCourse() {
      try {
        const data = await getCourseBySlug(courseSlug)
        setCourse(data)
      } catch (err) {
        console.error("Failed to load course", err)
      } finally {
        setLoading(false)
      }
    }

    loadCourse()

  }, [courseSlug])


  if (loading) {
    return (
      <div className="course-loading">
        Loading course...
      </div>
    )
  }


  if (!course) {
    return (
      <div className="not-found">
        <h1>Course Not Found</h1>
        <Link to="/courses">← Back to all courses</Link>
      </div>
    )
  }


  return (
    <div className="course-detail-page">

      {/* Hero / Header */}
      <section className="course-header">
        <div className="container">

          <Link to="/courses" className="back-link">
            <ArrowLeft size={18} /> All Courses
          </Link>

          <h1>{course.title}</h1>

          <p className="course-lead">{course.overview}</p>


          {/* RAW Course Overview */}
          {course.fullOverview && (
            <div className="course-overview-raw">
              <h2>Course Overview</h2>
              {course.fullOverview.map((para, idx) => (
                <p key={idx}>{para}</p>
              ))}
            </div>
          )}


          <div className="course-meta-grid">

            <div className="meta-item">
              <Calendar size={20} />
              <div>
                <span className="meta-label">Duration</span>
                <span className="meta-value">{course.duration}</span>
              </div>
            </div>

            <div className="meta-item">
              <DollarSign size={20} />
              <div>
                <span className="meta-label">Investment</span>
                <span className="meta-value">
                  {course.fee}
                  <small>Student/CSO: {course.studentFee}</small>
                </span>
              </div>
            </div>

            <div className="meta-item">
              <Globe size={20} />
              <div>
                <span className="meta-label">Delivery</span>
                <span className="meta-value">{course.modes}</span>
              </div>
            </div>

            <div className="meta-item">
              <Award size={20} />
              <div>
                <span className="meta-label">Certification</span>
                <span className="meta-value">{course.certificate}</span>
              </div>
            </div>

          </div>


          <div className="header-cta">
            <a
              href="https://forms.gle/MQrW26EzTQVGNCxY9"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary large"
            >
              Apply Now
            </a>
          </div>

        </div>
      </section>


      <main className="course-main container">

        <div className="content-grid">

          <div className="main-content">


            {course.learningOutcomes?.length > 0 && (
              <section className="course-section">
                <h2>What You Will Gain</h2>
                <ul className="outcome-list">
                  {course.learningOutcomes.map((outcome, idx) => (
                    <li key={idx}>{outcome}</li>
                  ))}
                </ul>
              </section>
            )}


            {course.modules?.length > 0 && (
              <section className="course-section">
                <h2>Course Modules</h2>
                <ul className="module-list">
                  {course.modules.map((module, idx) => (
                    <li key={idx}>
                      <BookOpenCheck size={18} />
                      {module}
                    </li>
                  ))}
                </ul>
              </section>
            )}


            {course.about && (
              <section className="course-section">
                <h2>About This Course</h2>
                <p className="about-text">{course.about}</p>
              </section>
            )}


            {course.requirements && (
              <section className="course-section">
                <h2>Entry Requirements</h2>
                <p>{course.requirements}</p>
              </section>
            )}

          </div>


          <aside className="sidebar">

            <div className="sidebar-card">

              <h3>Course Snapshot</h3>

              <dl className="snapshot-list">

                <div>
                  <dt>Convener</dt>
                  <dd>{course.convener}</dd>
                </div>

                <div>
                  <dt>Duration</dt>
                  <dd>{course.duration}</dd>
                </div>

                <div>
                  <dt>Standard Fee</dt>
                  <dd>{course.fee}</dd>
                </div>

                <div>
                  <dt>Student / CSO Rate</dt>
                  <dd>{course.studentFee}</dd>
                </div>

                <div>
                  <dt>Format</dt>
                  <dd>{course.modes}</dd>
                </div>

                <div>
                  <dt>Target Audience</dt>
                  <dd>{course.targetAudience}</dd>
                </div>

              </dl>


              <a
                href="https://forms.gle/MQrW26EzTQVGNCxY9"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary block"
              >
                Secure Your Place
              </a>

            </div>

          </aside>

        </div>

      </main>

    </div>
  )
}
// import { useParams, Link } from 'react-router-dom';
// import {
//   ArrowLeft,
//   Calendar,
//   DollarSign,
//   Globe,
//   Award,
//   BookOpenCheck
// } from 'lucide-react';
// import './CourseDetail.css';
// import { coursesData } from '../../Data/courses';

// export default function CourseDetail() {
//   const { courseSlug } = useParams();
//   const course = coursesData.find(c => c.slug === courseSlug);

//   if (!course) {
//     return (
//       <div className="not-found">
//         <h1>Course Not Found</h1>
//         <Link to="/courses">← Back to all courses</Link>
//       </div>
//     );
//   }

//   return (
//     <div className="course-detail-page">

//       {/* Hero / Header */}
//       <section className="course-header">
//         <div className="container">
//           <Link to="/courses" className="back-link">
//             <ArrowLeft size={18} /> All Courses
//           </Link>

//           <h1>{course.title}</h1>

//           {/* Short lead */}
//           <p className="course-lead">{course.overview}</p>

//           {/* RAW Course Overview */}
//           {course.fullOverview && (
//             <div className="course-overview-raw">
//               <h2>Course Overview</h2>
//               {course.fullOverview.map((para, idx) => (
//                 <p key={idx}>{para}</p>
//               ))}
//             </div>
//           )}

//           <div className="course-meta-grid">
//             <div className="meta-item">
//               <Calendar size={20} />
//               <div>
//                 <span className="meta-label">Duration</span>
//                 <span className="meta-value">{course.duration}</span>
//               </div>
//             </div>

//             <div className="meta-item">
//               <DollarSign size={20} />
//               <div>
//                 <span className="meta-label">Investment</span>
//                 <span className="meta-value">
//                   {course.fee}
//                   <small>Student/CSO: {course.studentFee}</small>
//                 </span>
//               </div>
//             </div>

//             <div className="meta-item">
//               <Globe size={20} />
//               <div>
//                 <span className="meta-label">Delivery</span>
//                 <span className="meta-value">{course.modes}</span>
//               </div>
//             </div>

//             <div className="meta-item">
//               <Award size={20} />
//               <div>
//                 <span className="meta-label">Certification</span>
//                 <span className="meta-value">{course.certificate}</span>
//               </div>
//             </div>
//           </div>

//           <div className="header-cta">
//             <a
//               href="https://forms.gle/MQrW26EzTQVGNCxY9"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="btn-primary large"
//             >
//               Apply Now
//             </a>
//           </div>
//         </div>
//       </section>

//       <main className="course-main container">
//         <div className="content-grid">

//           <div className="main-content">

//             {course.learningOutcomes?.length > 0 && (
//               <section className="course-section">
//                 <h2>What You Will Gain</h2>
//                 <ul className="outcome-list">
//                   {course.learningOutcomes.map((outcome, idx) => (
//                     <li key={idx}>{outcome}</li>
//                   ))}
//                 </ul>
//               </section>
//             )}

//             <section className="course-section">
//               <h2>Course Modules</h2>
//               <ul className="module-list">
//                 {course.modules.map((module, idx) => (
//                   <li key={idx}>
//                     <BookOpenCheck size={18} />
//                     {module}
//                   </li>
//                 ))}
//               </ul>
//             </section>

//             <section className="course-section">
//               <h2>About This Course</h2>
//               <p className="about-text">{course.about}</p>
//             </section>

//             {course.requirements && (
//               <section className="course-section">
//                 <h2>Entry Requirements</h2>
//                 <p>{course.requirements}</p>
//               </section>
//             )}
//           </div>

//           <aside className="sidebar">
//             <div className="sidebar-card">
//               <h3>Course Snapshot</h3>
//               <dl className="snapshot-list">
//                 <div>
//                   <dt>Convener</dt>
//                   <dd>{course.convener}</dd>
//                 </div>
//                 <div>
//                   <dt>Duration</dt>
//                   <dd>{course.duration}</dd>
//                 </div>
//                 <div>
//                   <dt>Standard Fee</dt>
//                   <dd>{course.fee}</dd>
//                 </div>
//                 <div>
//                   <dt>Student / CSO Rate</dt>
//                   <dd>{course.studentFee}</dd>
//                 </div>
//                 <div>
//                   <dt>Format</dt>
//                   <dd>{course.modes}</dd>
//                 </div>
//                 <div>
//                   <dt>Target Audience</dt>
//                   <dd>{course.targetAudience}</dd>
//                 </div>
//               </dl>

//               <a
//                 href="https://forms.gle/MQrW26EzTQVGNCxY9"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="btn-primary block"
//               >
//                 Secure Your Place
//               </a>
//             </div>
//           </aside>

//         </div>
//       </main>
//     </div>
//   );
// }

// // src/pages/CourseDetail/CourseDetail.jsx
// import { useParams, Link } from 'react-router-dom';
// import { ArrowLeft, Calendar, DollarSign, Globe, Award, BookOpenCheck } from 'lucide-react';
// // import { coursesData } from '../../data/courses';
// // coursesData
// import './CourseDetail.css';
// import { coursesData } from '../../Data/courses';

// export default function CourseDetail() {
//   const { courseSlug } = useParams();
//   const course = coursesData.find(c => c.slug === courseSlug);

//   if (!course) {
//     return (
//       <div className="not-found">
//         <h1>Course Not Found</h1>
//         <Link to="/courses">← Back to all courses</Link>
//       </div>
//     );
//   }

//   return (
//     <div className="course-detail-page">

//       {/* Hero / Header */}
//       <section className="course-header">
//         <div className="container">
//           <Link to="/courses" className="back-link">
//             <ArrowLeft size={18} /> All Courses
//           </Link>

//           <h1>{course.title}</h1>
//           <p className="course-lead">{course.overview}</p>

//           <div className="course-meta-grid">
//             <div className="meta-item">
//               <Calendar size={20} />
//               <div>
//                 <span className="meta-label">Duration</span>
//                 <span className="meta-value">{course.duration}</span>
//               </div>
//             </div>

//             <div className="meta-item">
//               <DollarSign size={20} />
//               <div>
//                 <span className="meta-label">Investment</span>
//                 <span className="meta-value">
//                   {course.fee}
//                   <small>Student/CSO: {course.studentFee}</small>
//                 </span>
//               </div>
//             </div>

//             <div className="meta-item">
//               <Globe size={20} />
//               <div>
//                 <span className="meta-label">Delivery</span>
//                 <span className="meta-value">{course.modes}</span>
//               </div>
//             </div>

//             <div className="meta-item">
//               <Award size={20} />
//               <div>
//                 <span className="meta-label">Certification</span>
//                 <span className="meta-value">{course.certificate}</span>
//               </div>
//             </div>
//           </div>

//           <div className="header-cta">
//             <a
//               href="https://forms.gle/MQrW26EzTQVGNCxY9"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="btn-primary large"
//             >
//               Apply Now
//             </a>
//           </div>
//         </div>
//       </section>

//       <main className="course-main container">

//         {/* Two-column layout on larger screens */}
//         <div className="content-grid">

//           {/* Main content - left / wider column */}
//           <div className="main-content">

//             {course.learningOutcomes && course.learningOutcomes.length > 0 && (
//               <section className="course-section">
//                 <h2>What You Will Gain</h2>
//                 <ul className="outcome-list">
//                   {course.learningOutcomes.map((outcome, idx) => (
//                     <li key={idx}>{outcome}</li>
//                   ))}
//                 </ul>
//               </section>
//             )}

//             <section className="course-section">
//               <h2>Course Modules</h2>
//               <ul className="module-list">
//                 {course.modules.map((module, idx) => (
//                   <li key={idx}>
//                     <BookOpenCheck size={18} />
//                     {module}
//                   </li>
//                 ))}
//               </ul>
//             </section>

//             <section className="course-section">
//               <h2>About This Course</h2>
//               <p className="about-text">{course.about}</p>
//             </section>

//             {course.requirements && (
//               <section className="course-section">
//                 <h2>Entry Requirements</h2>
//                 <p>{course.requirements}</p>
//               </section>
//             )}
//           </div>

//           {/* Sidebar - right / narrower column */}
//           <aside className="sidebar">

//             <div className="sidebar-card">
//               <h3>Course Snapshot</h3>
//               <dl className="snapshot-list">
//                 <div>
//                   <dt>Convener</dt>
//                   <dd>{course.convener}</dd>
//                 </div>
//                 <div>
//                   <dt>Duration</dt>
//                   <dd>{course.duration}</dd>
//                 </div>
//                 <div>
//                   <dt>Standard Fee</dt>
//                   <dd>{course.fee}</dd>
//                 </div>
//                 <div>
//                   <dt>Student / CSO Rate</dt>
//                   <dd>{course.studentFee}</dd>
//                 </div>
//                 <div>
//                   <dt>Format</dt>
//                   <dd>{course.modes}</dd>
//                 </div>
//                 <div>
//                   <dt>Target Audience</dt>
//                   <dd>{course.targetAudience}</dd>
//                 </div>
//               </dl>

//               <a
//                 href="https://forms.gle/MQrW26EzTQVGNCxY9"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="btn-primary block"
//               >
//                 Secure Your Place
//               </a>
//             </div>

//           </aside>
//         </div>
//       </main>
      
//       {/* Footer */}
//       <footer className="footer">
//         <div className="footer-grid">
//           <div>
//             <div className="footer-logo">DevLearn Impact Research Ltd</div>
//             <p>Plot No. 3788/A, Avondale Road, Lusaka</p>
//             <p>+260 973 902 981 / +260 978 341 825</p>
//             <p>info@devlearnimpact.com</p>
//           </div>
//           <div>
//             <h4>Services</h4>
//             <ul>
//               <li><a href="/services">Applied Research</a></li>
//               <li><a href="/services">MERL Frameworks</a></li>
//               <li><a href="/services">Capacity Building</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Thematic Areas</h4>
//             <ul>
//               <li><a href="/sectors">Education & Health</a></li>
//               <li><a href="/sectors">Governance & Climate</a></li>
//               <li><a href="/sectors">Economic Inclusion</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Company</h4>
//             <ul>
//               <li><a href="/about">About</a></li>
//               <li><a href="/team">Team</a></li>
//               <li><a href="/case-studies">Projects</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Connect</h4>
//             <ul>
//               <li><a href="https://www.linkedin.com/company/devlearn-impact-research/">LinkedIn</a></li>
//               <li><a href="https://www.facebook.com/share/1AS3Ahfsy7/">Facebook</a></li>
//             </ul>
//           </div>
//         </div>
//         <div className="copyright">
//           © 2026 DevLearn Impact Research Ltd. All rights reserved. Registered in Zambia, June 28, 2025.
//         </div>
//       </footer>
//     </div>
//   );
// }

// // // src/pages/CourseDetail/CourseDetail.jsx
// // import { useParams, Link } from 'react-router-dom';
// // import { ArrowLeft, Calendar, DollarSign, Users, Award, BookOpen } from 'lucide-react';
// // // import { coursesData } from '../../data/courses';
// // // coursesData
// // import './CourseDetail.css';
// // import { coursesData } from '../../Data/courses';

// // export default function CourseDetail() {
// //   const { courseSlug } = useParams();
// //   const course = coursesData.find(c => c.slug === courseSlug);

// //   if (!course) {
// //     return (
// //       <div className="not-found">
// //         <h2>Course not found</h2>
// //         <Link to="/courses">← Back to all courses</Link>
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className="course-detail-page">
// //       <section className="course-hero">
// //         <div className="container">
// //           <Link to="/courses" className="back-link">
// //             <ArrowLeft size={20} /> Back to Courses
// //           </Link>
// //           <h1>{course.title}</h1>
// //           <p className="lead">{course.overview}</p>

// //           <div className="course-quick-info">
// //             <div className="info-item">
// //               <Calendar size={20} />
// //               <span>{course.duration}</span>
// //             </div>
// //             <div className="info-item">
// //               <DollarSign size={20} />
// //               <div>
// //                 <span>Standard: {course.fee}</span>
// //                 <small>Student/CSO: {course.studentFee}</small>
// //               </div>
// //             </div>
// //             <div className="info-item">
// //               <Users size={20} />
// //               <span>{course.modes}</span>
// //             </div>
// //             <div className="info-item">
// //               <Award size={20} />
// //               <span>{course.certificate}</span>
// //             </div>
// //           </div>

// //           <a href="https://forms.gle/MQrW26EzTQVGNCxY9" target="_blank" className="btn-apply-large">
// //             Apply Now
// //           </a>
// //         </div>
// //       </section>

// //       <section className="course-content container">
// //         <div className="grid-2">
// //           <div className="main-column">
// //             <h2>Course Modules</h2>
// //             <ul className="modules-list">
// //               {course.modules.map((module, i) => (
// //                 <li key={i}>
// //                   <BookOpen size={18} /> {module}
// //                 </li>
// //               ))}
// //             </ul>

// //             {course.learningOutcomes && (
// //               <>
// //                 <h2>What You Will Learn</h2>
// //                 <ul className="outcomes-list">
// //                   {course.learningOutcomes.map((outcome, i) => (
// //                     <li key={i}>{outcome}</li>
// //                   ))}
// //                 </ul>
// //               </>
// //             )}
// //           </div>

// //           <div className="sidebar">
// //             <div className="info-card">
// //               <h3>Course Details</h3>
// //               <dl>
// //                 <dt>Convener</dt>
// //                 <dd>{course.convener}</dd>

// //                 <dt>Duration</dt>
// //                 <dd>{course.duration}</dd>

// //                 <dt>Fee</dt>
// //                 <dd>
// //                   Standard: {course.fee}<br />
// //                   <small>Student/CSO rate: {course.studentFee}</small>
// //                 </dd>

// //                 <dt>Modes</dt>
// //                 <dd>{course.modes}</dd>

// //                 <dt>Requirements</dt>
// //                 <dd>{course.requirements || "None specified"}</dd>

// //                 <dt>Target Audience</dt>
// //                 <dd>{course.targetAudience || "Development professionals, students, researchers"}</dd>
// //               </dl>
// //             </div>

// //             <div className="apply-card">
// //               <h3>Ready to Join?</h3>
// //               <p>Secure your spot in this hands-on training.</p>
// //               <a href="https://forms.gle/MQrW26EzTQVGNCxY9" target="_blank" className="btn-apply">
// //                 Apply Now
// //               </a>
// //             </div>
// //           </div>
// //         </div>

// //         <div className="about-section">
// //           <h2>About This Course</h2>
// //           <p>{course.about}</p>
// //         </div>
// //       </section>
// //     </div>
// //   );
// // }